@if (safeArea) {
  <vw-header-padding-safe-area [look]="'white'"></vw-header-padding-safe-area>
}
<div class="flex h-12 items-center gap-2 px-2">
  <span class="flex h-target w-11 shrink-0 items-center justify-center">
    @if (showBack) {
      <button type="button" class="flex h-target w-11 items-center justify-center text-vw-ink" data-test="wizard-back"
        [attr.aria-label]="backLabelKey | translate" (click)="back.emit()">
        <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path d="m15 6-6 6 6 6" stroke-linecap="round" stroke-linejoin="round"></path></svg>
      </button>
    }
  </span>
  <h1 class="min-w-0 flex-1 truncate text-center text-body font-semibold text-vw-ink" data-test="wizard-title">{{ title ? (title | translate) : '' }}</h1>
  <span class="flex h-target w-11 shrink-0 items-center justify-center">
    @if (showClose) {
      <button type="button" class="flex h-target w-11 items-center justify-center text-vw-ink" data-test="wizard-close"
        [attr.aria-label]="closeLabelKey | translate" (click)="close.emit()">
        <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke-linecap="round"></path></svg>
      </button>
    }
  </span>
</div>
@if (hasProgress) {
  <div class="px-4 pb-3" data-test="wizard-progress">
    <p class="pb-2 text-caption text-vw-muted">{{ 'components.wizzard.step' | translate: { current: current, total: total } }}</p>
    <div class="h-1.5 w-full overflow-hidden rounded-full bg-vw-surface-tint" role="progressbar"
      [attr.aria-valuenow]="current" aria-valuemin="1" [attr.aria-valuemax]="total">
      <div class="h-full rounded-full bg-vw-primary transition-[width] duration-200 motion-reduce:transition-none"
        [style.width.%]="progressPercent"></div>
    </div>
  </div>
}
<ng-content></ng-content>
